<template>
  <div class="laonlbaner_fluid">
    <div class="laonlbaner">
      <div class="laont between">
        <div class="laonswi">
          <el-carousel trigger="click" height="320px" arrow="never">
            <el-carousel-item v-for="item in 4" :key="item">
              <div class="swiimg">
                <img src="../../../assets/findlawyers/banner_sample.png" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="laonsel">
          <div class="d1 flex_start">
            <img src="../../../assets/findlawyers/zuobiao.png" />合肥
          </div>
          <div class="t1">选择地区：</div>
          <div class="between">
            <el-select
              :popper-append-to-body="false"
              v-model="value"
              placeholder="请选择"
              class="sele1"
            >
              <el-option
                v-for="item in provincecity"
                :key="item.id"
                :label="item.name"
                :value="index"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="value1"
              :popper-append-to-body="false"
              placeholder="请选择"
              class="sele1"
            >
              <el-option
               v-for="item in provincecity[theindex].children"
               :key="item.id"
               :label="item.name"
               :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="t1">选择专长：</div>
          <div class="between">
            <el-select
              :popper-append-to-body="false"
              v-model="value2"
              placeholder="请选择"
              class="sele2"
            >
              <el-option
                v-for="item in majors"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="kscz">快速查找</div>
        </div>
      </div>
      <div class="jin between">
        <div class="jin_item center">
          <div class="img1 center">
            <img src="../../../assets/lawyerOnline/rt.png" alt="" />
          </div>
          <div class="te1">
            <div class="t1">12809</div>
            <div class="t2">今日在线律师</div>
          </div>
        </div>
        
        <div class="jin_item center">
          <div class="img1 center">
            <img src="../../../assets/lawyerOnline/zixun.png" alt="" />
          </div>
          <div class="te1">
            <div class="t1">12809</div>
            <div class="t2">今日在线咨询数</div>
          </div>
        </div>
        
        <div class="jin_item center">
          <div class="img1 center">
            <img src="../../../assets/lawyerOnline/jieda-.png" alt="" />
          </div>
          <div class="te1">
            <div class="t1">12809</div>
            <div class="t2">今日在线解答数</div>
          </div>
        </div>




      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "homemenubanner",
  data() {
    return {
     provincecity:[],
     majors:[],
     theindex:0,
     value: "北京",
     value1: "北京",
     value2: "",
    };
  },
  created() {
  	  // alert(this.$route.params.test)
  	this.$http.home.provincecity().then(res =>{
  		this.provincecity = res.data
  		this.value = this.provincecity[0].name
  		this.value1 = this.provincecity[0].children[0].name
  	})
  	this.$http.home.majors().then(res =>{
  		this.majors = res.data
  		this.value2 = this.majors[0].name
  	})
  },
  methods:{
  	  changeprov(e){
  		  this.theindex = e
  		  console.log(e)
  	  },
  	  tooffice(){
  		  this.$router.push({
  			  name:'seafirms',
  			  params:{
  				 test:123 
  			  }
  		  })
  	  }
  }
};
</script>


<style lang="scss" scoped>
.laonlbaner_fluid {
  width: 100%;
  background: url("../../../assets/lawyerOnline/laonlbaner_bg.png");
  padding: 50px 0 0;
  .laonlbaner {
    width: 1200px;
    margin: 0 auto;
    .laont {
      .laonswi {
        width: 840px;
        height: 320px;
        background-color: #e7e7e7;
        ::v-deep .is-active {
          .el-carousel__button {
            background-color: #1f7dff;
          }
        }
        .swiimg {
          img {
            width: 840px;
            height: 320px;
          }
        }
      }
      .laonsel {
        width: 330px;
        height: 320px;
        padding: 28px 25px;
        background-color: #fff;
        box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.08);
        .d1 {
          font-size: 20px;
          font-weight: bold;
          color: #000000;
          img {
            width: 18px;
            height: 22px;
            margin-right: 8px;
          }
        }
        .t1 {
          margin-top: 18px;
          margin-bottom: 10px;
          font-size: 14px;
          color: #666666;
        }
        .sele1 {
          width: 134px;
          height: 40px;
        }
        .sele2 {
          width: 100%;
          height: 40px;
        }
        .kscz {
          cursor: pointer;
          margin-top: 20px;
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          background: #0465ea;
          border-radius: 5px;
        }
      }
    }
    .jin {
      width: 1080px;
      height: 140px;
      margin: 0 auto;
      background-color: #fff;
      box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.08);
      border-radius: 5px;
      position: relative;
      top: 70px;
      .jin_item {
        flex: 1;
        border-right: 1px solid #d7d7d7;
        &:last-child {
          border-right: none;
        }
        .img1 {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 2px solid #b6b6b6;
          margin-right: 20px;
        }
        .te1 {
          text-align: left;
          .t1 {
            font-size: 24px;
            line-height: 24px;
            color: #333333;
          }
          .t2 {
            margin-top: 10px;
            font-size: 16px;
            color: #878787;
          }
        }
      }
    }
  }
}
</style>